import he from "he";
import { useLocation } from "react-router-dom";
import { SITE_URL } from "./seoConfig";

// Strips HTML tags and decodes entities out of API-supplied HTML fields
// (e.g. package `overview`, blog `LongDescription`) so they are safe to use
// inside <meta name="description">. This never touches the visible page
// content, which keeps rendering dangerouslySetInnerHTML markup as-is.
export const stripHtmlToText = (html) => {
  if (!html) return "";
  const withoutTags = String(html).replace(/<[^>]*>/g, " ");
  const decoded = he.decode(withoutTags);
  return decoded.replace(/\s+/g, " ").trim();
};

// Produces a clean, plain-text meta description of a bounded length without
// cutting the final word in half.
export const toMetaDescription = (html, maxLength = 160) => {
  const text = stripHtmlToText(html);
  if (!text) return "";
  if (text.length <= maxLength) return text;

  const truncated = text.slice(0, maxLength);
  const lastSpace = truncated.lastIndexOf(" ");
  const safe = lastSpace > 40 ? truncated.slice(0, lastSpace) : truncated;
  return `${safe.trim()}…`;
};

// Resolves a possibly-relative URL/path (route path, image path) to an
// absolute URL against the production site host.
export const toAbsoluteUrl = (value) => {
  if (!value) return undefined;
  const str = String(value).trim();
  if (!str) return undefined;
  if (/^https?:\/\//i.test(str)) return str;
  return `${SITE_URL}${str.startsWith("/") ? "" : "/"}${str}`;
};

// Mirrors the clean-path logic in App.js's <CanonicalTag> so JSON-LD "url"
// fields always agree with the actual rendered canonical/og:url tags.
export const useCanonicalUrl = () => {
  const { pathname } = useLocation();
  const cleanPath = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return `${SITE_URL}${cleanPath}`;
};
